import {FieldConfig} from '../../dynamic-field/field.config';

export interface ImageFieldConfig extends FieldConfig<string> {
    width?: string;
    height?: string;
    click?: () => {};
    setSource?: () => Promise<string>;
}
